<template>
  <div class="is-centered">
    <span
      v-for="(tag, index) in tags"
      :key="`t${index}`"
      :class="[$style.tagStyle, { 'is-dark': tag.isSelected }]"
      class="tag is-light"
      @click="setTagFilter(tag)"
      >{{ tag.name }}</span
    >
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ExtractorFilter",
  props: {
    tags: {
      data: {
        type: Array,
        default: () => [],
      },
    },
  },
  methods: {
    ...mapActions("root", ["setTagFilter"]),
  },
};
</script>

<style lang="scss" module>
.tagStyle {
  cursor: pointer;
  margin-right: 20px;
}

.tagStyle:last-child {
  margin-right: 0;
}
</style>
